import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from "clsx";
import styles from "./CardPage.module.scss";
export default function CardPage(_a) {
    var { children, footer } = _a, props = __rest(_a, ["children", "footer"]);
    return (_jsxs("div", { className: styles.container, children: [_jsx("div", Object.assign({}, props, { className: clsx(styles.card, props.className), children: children })), _jsx("div", { children: footer })] }));
}
